import {ReturnedPayment as ReturnedPaymentLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

export type ReturnedPaymentLetterProps = {
  returnedPaymentLetter: ReturnedPaymentLetter;
};

const ReturnedPayment = (props: ReturnedPaymentLetterProps) => {
  return (
    <>
      <CardField name={'Insured Name'} value={props.returnedPaymentLetter.insuredName} ddprivacy="mask"/>
      <CardField name={'Owner Name'} value={props.returnedPaymentLetter.ownerName} ddprivacy="mask"/>
      <CardField name={'Owner Address'} value={props.returnedPaymentLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name={'Policy Number'} value={props.returnedPaymentLetter.policyNumber} ddprivacy="mask"/>
      <CardField name={'Date'} value={toFormattedDateAsUTC(props.returnedPaymentLetter.date)} />
      <CardField name={'Agent Number'} value={props.returnedPaymentLetter.agentNumber} />
      <CardField name={'Amount Returned'} value={toMoneyValue(props.returnedPaymentLetter.amountReturned)} />
      <CardField name={'Bank Number'} value={props.returnedPaymentLetter.bankNumber} ddprivacy="mask"/>
    </>
  );
};

export default ReturnedPayment;
